import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dropdown } from 'primereact/dropdown';
import { Api } from '../../../services/api';
import { FaCopy, FaPencilAlt } from 'react-icons/fa';

const BillableConfig = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [globalFilter] = useState('');
    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            excelTitle: '',
            header: '',

        },

        validate: (data) => {
            let errors = {};

            if (!data.excelTitle) {
                errors.excelTitle = 'Title is required.';
            } if (!data.header) {
                errors.header = 'Please Select a Item.';
            }

            return errors;
        },

        onSubmit: (data) => {
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
               'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
      
            var url = Api.API_BASE_URL + 'billable-config-save';
            if (type == "Edit") {
                url = Api.API_BASE_URL + 'billable-config-update/' + projectTypeID;
            }


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        closeModal();
                        getProjectType();
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            console.log(data);
        }
    });
    // -------------------------------------------------------------




    const [pageNumber, setPageNumber] = useState(0);
    const projectsPerPage = 5;
    const pagesVisited = pageNumber * projectsPerPage;

    const pageCount = Math.ceil(projectType.length / projectsPerPage);

    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };

    const displayedProjects = projectType.slice(pagesVisited, pagesVisited + projectsPerPage);


    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [project, setProject] = useState();
    const [projectTypeID, setProjectTypeID] = useState();
    const [projectTypeName, setProjectTypeName] = useState();
    const [projectTypeStatus, setProjectTypeStatus] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);


    const openModal = () => {
        setProjectTypeID('');
        formik.resetForm();
        setType('Add');
        setTitle('Add Billable Config');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };

    const stopPropagation = (e) => {
        e.stopPropagation(); // Prevent the click from propagating to the overlay
    };

    const editModal = (row) => {
        setProjectTypeID(row._id);
        formik.setFieldValue('excelTitle', row.excelTitle);
        formik.setFieldValue('header', row.header);

        setType('Edit');
        setTitle('Edit Project Type');
        setIsModalOpen(true);
    };

    const openCopyModal = (row) => {
        formik.setFieldValue('excelTitle', row.excelTitle);
        formik.setFieldValue('header', row.header);
        setType('Add');
        setTitle('Copy Project Type');
        setIsModalOpen(true);
    };


    useEffect(() => {
        console.log('Fetching projects...xx');
        getProjectType();
        // console.log(getProjectType());
    }, []);

    const getProjectType = (project) => {

        // console.log("done======");
        // axios.get(API_BASE_URL + 'get-all-qb-project')
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
           'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
  
        axios.get(Api.API_BASE_URL + 'billable-config',{headers})
            .then((response) => {

                var data = response.data.result;
                var data2 = response.data.billableTitle;


                setProjectType(data);
                setSearchProjectType(data);
                setProject(data2);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });


    };



    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
               
                <div onClick={(e) => e.stopPropagation()}>
                    <FaCopy title='Copy the EXCEL' onClick={() => openCopyModal(rowData)} style={{ marginRight: '10px', color: 'orange' }} />

                    {/* <FaPencilAlt onClick={() => editModal(rowData)} style={{  }} /> */}
                </div>
            </React.Fragment>
        );
    };

    const handleDeleteProject = (projectId,) => {
        setProjectTypeID(projectId);
        setIsDeleteConfirmationModalOpen(true);
    };


    const confirmDelete = async () => {
        axios.get(Api.API_BASE_URL + 'get-all-qb-project-delete/' + projectTypeID)
            .then((response) => {
                toast.current.show({ severity: 'info', summary: 'Confirmed', detail: response.data.result, life: 3000 });
                getProjectType();
                closeModal();
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);

        setProjectType([]);
        const searchResult = searchProjectType.filter((item) =>
            item.excelTitle.toLowerCase().includes(searchValue.toLowerCase())
        );

        setProjectType(searchResult);
        console.log(searchResult)
    }

    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <h4 > </h4>
            <span className="p-input-icon-left ">
                <InputText className="input-field" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    const onRowSelect = (e) => {
        const rowData = e.data;
        editModal(rowData);
    };



    return (
        <>

            {/* // -------------------------------------------------------------------------------------- */}

            <div style={{ textAlign: "end", padding: "10px 10px 0px" }}>
                <button title='Add a new BILLABLE CONFIG-EXCEL' type="button" className="custom-button" onClick={openModal} >
                    + ADD
                </button>
            </div>

            {/* ----------------------------------------------------------------------------------------  */}

            <div className="pagee-container">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <DataTable value={projectType} paginator rows={12} key="id" 
                        selectionMode="single"
                        onRowSelect={onRowSelect}
                        onSelectionChange={(e) => setSelectedProduct(e.value)} 
                        tableStyle={{ minWidth: '50rem' }}  header={header} globalFilter={globalFilter} >
                          
                            <Column key="action" body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }} />

                            <Column key="excelTitle" field="excelTitle" header="Excel Title" />
                            <Column key="header" field="header" header="Headers" />

                        </DataTable>
                    )}
                </div>
            </div>
            {/* ---------------------------------------------------------------*/}
            <Dialog header="" visible={isModalOpen} maximizable style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsModalOpen(false)}>
                <div className='p-4'>
                    <form onSubmit={formik.handleSubmit} className="" >
                        <div className=" flex">

                            <div className="col-6 mt-4">
                                <label >Excel Title</label>
                                <InputText
                                    id="excelTitle"
                                    name="excelTitle"
                                    value={formik.values.excelTitle}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('excelTitle', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('excelTitle') })} style={{ width: '100%' }}
                                />
                            </div>


                            <div className="col-6 mt-4">
                                <label>Select Item</label>
                                <Dropdown
                                    optionValue='id'
                                    id="header"
                                    name="header"
                                    placeholder="Select a Project"
                                    options={project}
                                    optionLabel="name"
                                    value={formik.values.header}

                                    onChange={(e) => {
                                        console.log(e.value);
                                        formik.setFieldValue('header', e.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('header') })} style={{ width: '100%' }}
                                />
                            </div>


                        </div>
                        <div  className="w-full flex mt-5" style={{justifyContent:'center'}}>
                            <Button label="Submit" type="submit" className='p-2 customSave-button ' />
                        </div>


                    </form>


                </div>
            </Dialog>

            {/* ---------------------------------------------------------------*/}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>"Are you sure you want to delete this project? "</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default BillableConfig